import { val } from "angular-ui-router";

export const featurePermissionDirective = ($cookies) => {
	'ngInject';
	return {
		restrict: 'A',
		link: (scope, element, attrs, ngModel) => {
			const featureObject = $cookies.getObject('features')
			const feature = featureObject.find(({ feature }) => feature === attrs.feature)
			const permissions = feature.permissions.find(value => value === attrs.permission)
			if(!permissions){
				element.replaceWith('');
			}
		}
	};
};


// WEBPACK FOOTER //
// ./src/app/common/components/feature-permission/feature-permission.directive.js